module.exports = __webpack_public_path__ + "static/media/personafx_logo-color.99a31fb3.png";